/**
 * "Seen On" media mentions carousel
 * Creates an auto-playing slider for media logos and brand mentions
 * Displays social proof and media coverage with responsive breakpoints
 */

(async () => {

    if (!customElements.get('seen-on-swiper')) {
  
      const { default: Swiper, Navigation, Pagination, Scrollbar, Autoplay } = await import("swiper");
  
      Swiper.use([
        Navigation,
        Pagination,
        Scrollbar,
        Autoplay
      ]);
  
      class SeenOn extends HTMLElement {
        constructor() {
          super();
          this.swiperElement = this.querySelector('[data-swiper-seen-on]');
          this.swiperOptions = {
            loop: true,
            autoplay: true,
            slidesPerView: 2,         
            spaceBetween: 16,
            direction: 'horizontal',
            breakpoints: {
              375: {
                slidesPerView: 2
              },
              768: {
                slidesPerView: 4
              },
              1200: {
                slidesPerView: 6
              }
            }
          }
  
          // Check if we have extra options on the HTML
          if (this && this.dataset && this.dataset.options) {
            const jsonOptions = JSON.parse(this.dataset.options);
            if (jsonOptions) {
              this.swiperOptions = {
                ...this.swiperOptions,
                ...jsonOptions
              };
            }
          }
  
          // re-init slider when Theme Editor is active
          if (Shopify.designMode && this.swiperInstance) {
            window.addEventListener('shopify:section:load', () => {
              this.swiperInstance.update();
            });
          }
          this.init();
        }
  
        init() {
          this.swiperInstance = new Swiper(this.swiperElement, this.swiperOptions);
        }
  
      }
  
      window.SeenOn = SeenOn;
  
      customElements.define('seen-on-swiper', SeenOn);
  
    }
  
  })();
  